import React, { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { ToastContainer, toast } from 'react-toastify';
import { setMessage } from "../../actions/message";
import { getCompany, upsertCompany } from "../../actions/company";
import { useEffect } from "react";
import { getBankAccounts, deleteBankAccount, upsertBankAccount } from "../../actions/bankaccount";
import { clearMessage } from "../../actions/message";
import Filter from "../Filter";
import DeleteIcon from "@mui/icons-material/Delete";
import { DataGridPro, GridActionsCellItem } from '@mui/x-data-grid-pro';
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import BankAccountModal from "./BankAccountModal";

const BankAccount = (props) => {

  let bankaccountsLoaded = false;
  const dispatch = useDispatch();
  const { bankaccounts: listBankAccounts } = useSelector((state) => state.bankaccounts);
  const { message: message } = useSelector((state) => state.message);
  const [filter, setFilter] = useState("");
  const [activeFilter, setActiveFilter] = useState(true);
  const searchBarHelper = "Search for a bank account...";


  const [modalShow, setModalShow] = useState(false);
  const [selectedBankAccount, setSelectedBankAccount] = useState(null);


  const handleClickOpenDialog = () => {
    let bankaccount_tmp = {};
    bankaccount_tmp.id = 0;
    bankaccount_tmp.name = "";
    bankaccount_tmp.iban = "";
    bankaccount_tmp.bic = "";
    bankaccount_tmp.address = "";
    bankaccount_tmp.active = 1;
    setSelectedBankAccount(bankaccount_tmp);
    setModalShow(true);
  };

  const handleCloseDialog = () => {
    //upsert_bankaccount(selectedBankAccount);
    setModalShow(false);
    setSelectedBankAccount(null);
  };

  useEffect(() => {
    if (!bankaccountsLoaded) {
      dispatch(getBankAccounts()).then(() => {
        bankaccountsLoaded = true;
      }).catch((e) => {
      });
    }
  }, []);

  const updateActiveFilter = (e) => {
    setActiveFilter(e.target.checked);
  }

  const HandleFilter = (e) => {
    setFilter(e.toLowerCase());
  };

  function filterBankAccounts(bankaccount) {
    if (bankaccount.id > 0) {
      if (!bankaccount.active && activeFilter) {
        return false
      }

      if (bankaccount.name) {
        return bankaccount.name.toLowerCase().includes(filter);
      } else {
        return true;
      }
    }
  }

  const handleRowClick = (params) => {
    if (params.id > 0) {
      const bankaccount = listBankAccounts.filter(bankaccount => { return bankaccount.id === params.id })[0]
      if (bankaccount.id <= 0) { return; }
      setSelectedBankAccount(bankaccount);
      setModalShow(true);
    }
  };

  const upsert_bankaccount = () => {
    setModalShow(false);
    if ((selectedBankAccount.id >= 0 && selectedBankAccount.name != "")) {
      dispatch(upsertBankAccount(selectedBankAccount))
        .then(() => {
          toast.success(
            `Bank account ${selectedBankAccount.id > 0 ? "updated" : "created"} successfuly`,
            { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
          );
        })
        .catch(() => {
          toast.error(
            `An Error occured while ${selectedBankAccount.id > 0 ? "updating" : "creating"} the bank account. Try again later.`,
            { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
          );
        });
    }

    setSelectedBankAccount(null);

  }


  const delete_bankaccount = (bankaccount_id) => {
    dispatch(deleteBankAccount(bankaccount_id))
      .then(() => {
        toast.success(
          `Bank account deleted successfuly`,
          { autoClose: 1250, position: toast.POSITION.BOTTOM_CENTER }
        );
      })
      .catch(() => {
        toast.error(
          `This bank account can't be deleted due to links in the app.`,
          { autoClose: 1250, position: toast.POSITION.BOTTOM_CENTER }
        );
        dispatch(clearMessage());
      });
  }

  const columns = [
    { field: 'id', headerName: 'ID', hide: true },
    { field: 'name', headerName: 'Name', flex: 1 },
    { field: 'iban', headerName: 'IBAN', flex: 1 },
    { field: 'bic', headerName: 'BIC', flex: 1 },
    { field: 'address', headerName: 'Address', flex: 1 },
    {
      field: 'actions',
      type: 'actions',
      sortable: false,
      getActions: (params) => {
        return [<GridActionsCellItem icon={params.id > 0 ? <DeleteIcon /> : <></>} onClick={() => delete_bankaccount(params.id)} />]
      }
    }];

  return (
    <div>
      <div className="container">
        <div className="justify-content-end d-flex p-3 m-6">
          <Filter
            setSearchQuery={HandleFilter}
            searchQuery={filter}
            helper={searchBarHelper}
            setActive={updateActiveFilter}
            addDataFunction={() => handleClickOpenDialog()}
          />

          <BankAccountModal
            show={modalShow}
            setSelectedBankAccount={setSelectedBankAccount}
            selectedBankAccount={selectedBankAccount}
            handleSubmit={upsert_bankaccount}
            onHide={() => handleCloseDialog(false)}>
          </BankAccountModal>

        </div>
      </div>
      {
        listBankAccounts ?
          <div style={{ height: 400, width: '100%' }}>
            <DataGridPro
              component={Paper}
              rows={
                listBankAccounts.filter(filterBankAccounts).map((bankaccount) => {
                  return bankaccount;
                })}
              columns={columns}
              onRowClick={handleRowClick}
              initialState={{ pinnedColumns: { right: ['actions'] } }}
              getRowClassName={(params) => {
                return !params.row.id ? `row-parent` : `row-child-${(listBankAccounts.filter((u) => u.id == params.row.id)[0].active ? "active" : "inactive")}`
              }}
            />
          </div> : <></>
      }
    </div>
  )
};

export default BankAccount;